/**
 * All Microsoft Azure Speech SDK supported languages for Language Identification.
 * Source: C2HL.RealTimeTranslation.Server/Configuration/AzureSpeechCandidateLanguages.json
 * Reference: https://learn.microsoft.com/en-us/azure/ai-services/speech-service/language-support
 *
 * Format: 'English Name - NativeName' for easy searching in both languages.
 * All codes are in BCP-47 format (xx-YY).
 */
export const SUPPORTED_LANGUAGES = [
    { code: 'af-ZA', name: 'Afrikaans' },
    { code: 'sq-AL', name: 'Albanian - Shqip' },
    { code: 'am-ET', name: 'Amharic - አማርኛ' },
    { code: 'ar-SA', name: 'Arabic - العربية' },
    { code: 'hy-AM', name: 'Armenian - Հայերdelays' },
    { code: 'as-IN', name: 'Assamese - অসমীয়া' },
    { code: 'az-AZ', name: 'Azerbaijani - Azərbaycan' },
    { code: 'eu-ES', name: 'Basque - Euskara' },
    { code: 'be-BY', name: 'Belarusian - Беларуская' },
    { code: 'bn-IN', name: 'Bengali - বাংলা' },
    { code: 'bs-BA', name: 'Bosnian - Bosanski' },
    { code: 'bg-BG', name: 'Bulgarian - Български' },
    { code: 'my-MM', name: 'Burmese - မြန်မာ' },
    { code: 'ca-ES', name: 'Catalan - Català' },
    { code: 'zh-CN', name: 'Chinese Simplified - 简体中文' },
    { code: 'zh-TW', name: 'Chinese Traditional - 繁體中文' },
    { code: 'zh-HK', name: 'Chinese Cantonese (Hong Kong) - 粵語' },
    { code: 'yue-CN', name: 'Chinese Cantonese (China) - 粤语' },
    { code: 'wuu-CN', name: 'Wu Chinese - 吴语' },
    { code: 'hr-HR', name: 'Croatian - Hrvatski' },
    { code: 'cs-CZ', name: 'Czech - Čeština' },
    { code: 'da-DK', name: 'Danish - Dansk' },
    { code: 'nl-NL', name: 'Dutch - Nederlands' },
    { code: 'nl-BE', name: 'Dutch (Belgium) - Nederlands' },
    { code: 'en-US', name: 'English (United States)' },
    { code: 'en-GB', name: 'English (United Kingdom)' },
    { code: 'en-AU', name: 'English (Australia)' },
    { code: 'en-IN', name: 'English (India)' },
    { code: 'en-PH', name: 'English (Philippines)' },
    { code: 'en-NG', name: 'English (Nigeria)' },
    { code: 'en-ZA', name: 'English (South Africa)' },
    { code: 'et-EE', name: 'Estonian - Eesti' },
    { code: 'fil-PH', name: 'Filipino' },
    { code: 'fi-FI', name: 'Finnish - Suomi' },
    { code: 'fr-FR', name: 'French - Français' },
    { code: 'fr-CA', name: 'French (Canada) - Français' },
    { code: 'fr-BE', name: 'French (Belgium) - Français' },
    { code: 'fr-CH', name: 'French (Switzerland) - Français' },
    { code: 'gl-ES', name: 'Galician - Galego' },
    { code: 'ka-GE', name: 'Georgian - ქართული' },
    { code: 'de-DE', name: 'German - Deutsch' },
    { code: 'de-AT', name: 'German (Austria) - Deutsch' },
    { code: 'de-CH', name: 'German (Switzerland) - Deutsch' },
    { code: 'el-GR', name: 'Greek - Ελληνικά' },
    { code: 'gu-IN', name: 'Gujarati - ગુજરાતી' },
    { code: 'he-IL', name: 'Hebrew - עברית' },
    { code: 'hi-IN', name: 'Hindi - हिन्दी' },
    { code: 'hu-HU', name: 'Hungarian - Magyar' },
    { code: 'is-IS', name: 'Icelandic - Íslenska' },
    { code: 'id-ID', name: 'Indonesian - Bahasa Indonesia' },
    { code: 'ga-IE', name: 'Irish - Gaeilge' },
    { code: 'zu-ZA', name: 'isiZulu' },
    { code: 'it-IT', name: 'Italian - Italiano' },
    { code: 'it-CH', name: 'Italian (Switzerland) - Italiano' },
    { code: 'ja-JP', name: 'Japanese - 日本語' },
    { code: 'jv-ID', name: 'Javanese - Basa Jawa' },
    { code: 'kn-IN', name: 'Kannada - ಕನ್ನಡ' },
    { code: 'kk-KZ', name: 'Kazakh - Қазақ' },
    { code: 'km-KH', name: 'Khmer - ខ្មែរ' },
    { code: 'sw-KE', name: 'Swahili - Kiswahili' },
    { code: 'sw-TZ', name: 'Swahili (Tanzania) - Kiswahili' },
    { code: 'ko-KR', name: 'Korean - 한국어' },
    { code: 'lo-LA', name: 'Lao - ລາວ' },
    { code: 'lv-LV', name: 'Latvian - Latviešu' },
    { code: 'lt-LT', name: 'Lithuanian - Lietuvių' },
    { code: 'mk-MK', name: 'Macedonian - Македонски' },
    { code: 'ms-MY', name: 'Malay - Bahasa Melayu' },
    { code: 'ml-IN', name: 'Malayalam - മലയാളം' },
    { code: 'mt-MT', name: 'Maltese - Malti' },
    { code: 'mr-IN', name: 'Marathi - मराठी' },
    { code: 'mn-MN', name: 'Mongolian - Монгол' },
    { code: 'ne-NP', name: 'Nepali - नेपाली' },
    { code: 'nb-NO', name: 'Norwegian - Norsk Bokmål' },
    { code: 'or-IN', name: 'Odia - ଓଡ଼ିଆ' },
    { code: 'ps-AF', name: 'Pashto - پښتو' },
    { code: 'fa-IR', name: 'Persian - فارسی' },
    { code: 'pl-PL', name: 'Polish - Polski' },
    { code: 'pt-BR', name: 'Portuguese (Brazil) - Português' },
    { code: 'pt-PT', name: 'Portuguese - Português' },
    { code: 'pa-IN', name: 'Punjabi - ਪੰਜਾਬੀ' },
    { code: 'ro-RO', name: 'Romanian - Română' },
    { code: 'ru-RU', name: 'Russian - Русский' },
    { code: 'sr-RS', name: 'Serbian - Српски' },
    { code: 'si-LK', name: 'Sinhala - සිංහල' },
    { code: 'sk-SK', name: 'Slovak - Slovenčina' },
    { code: 'sl-SI', name: 'Slovenian - Slovenščina' },
    { code: 'so-SO', name: 'Somali - Soomaali' },
    { code: 'es-ES', name: 'Spanish - Español' },
    { code: 'es-MX', name: 'Spanish (Mexico) - Español' },
    { code: 'es-US', name: 'Spanish (US) - Español' },
    { code: 'es-AR', name: 'Spanish (Argentina) - Español' },
    { code: 'es-CO', name: 'Spanish (Colombia) - Español' },
    { code: 'es-CL', name: 'Spanish (Chile) - Español' },
    { code: 'es-PE', name: 'Spanish (Peru) - Español' },
    { code: 'es-VE', name: 'Spanish (Venezuela) - Español' },
    { code: 'es-BO', name: 'Spanish (Bolivia) - Español' },
    { code: 'es-CR', name: 'Spanish (Costa Rica) - Español' },
    { code: 'es-CU', name: 'Spanish (Cuba) - Español' },
    { code: 'es-DO', name: 'Spanish (Dominican Republic) - Español' },
    { code: 'es-EC', name: 'Spanish (Ecuador) - Español' },
    { code: 'es-GQ', name: 'Spanish (Equatorial Guinea) - Español' },
    { code: 'es-GT', name: 'Spanish (Guatemala) - Español' },
    { code: 'es-HN', name: 'Spanish (Honduras) - Español' },
    { code: 'es-NI', name: 'Spanish (Nicaragua) - Español' },
    { code: 'es-PA', name: 'Spanish (Panama) - Español' },
    { code: 'es-PR', name: 'Spanish (Puerto Rico) - Español' },
    { code: 'es-PY', name: 'Spanish (Paraguay) - Español' },
    { code: 'es-SV', name: 'Spanish (El Salvador) - Español' },
    { code: 'es-UY', name: 'Spanish (Uruguay) - Español' },
    { code: 'sv-SE', name: 'Swedish - Svenska' },
    { code: 'ta-IN', name: 'Tamil - தமிழ்' },
    { code: 'te-IN', name: 'Telugu - తెలుగు' },
    { code: 'th-TH', name: 'Thai - ไทย' },
    { code: 'tr-TR', name: 'Turkish - Türkçe' },
    { code: 'uk-UA', name: 'Ukrainian - Українська' },
    { code: 'ur-IN', name: 'Urdu - اردو' },
    { code: 'uz-UZ', name: 'Uzbek - Oʻzbek' },
    { code: 'vi-VN', name: 'Vietnamese - Tiếng Việt' },
    { code: 'cy-GB', name: 'Welsh - Cymraeg' }
];

/**
 * Popular languages shown at the top of the dropdown when no search query.
 * These are the default candidate languages for Azure Speech SDK.
 */
export const POPULAR_LANGUAGES = [
    'en-US',
    'es-ES',
    'zh-CN',
    'ko-KR',
    'ja-JP',
    'de-DE',
    'fr-FR',
    'pt-BR',
    'it-IT',
    'ru-RU'
];

/**
 * Get language display name by code.
 * @param {string} code - Language code (e.g., 'en', 'ko-KR')
 * @returns {string} Display name or the code if not found
 */
export function getLanguageName(code) {
    const lang = SUPPORTED_LANGUAGES.find(l => l.code === code);
    return lang ? lang.name : code;
}
